"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _prismicReactjs = require("prismic-reactjs");
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Grid = _interopRequireDefault(require("@commerce-ui/core2/Grid"));
var _Container = _interopRequireDefault(require("@commerce-ui/core2/Container"));
var _core = require("@commerce-ui/core2");
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _getRouteFromUrl = _interopRequireDefault(require("@deosite/helpers/getRouteFromUrl"));
var _prismicErrorHandle = require("@deosite/helpers/prismicErrorHandle");
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FacebookIcon = function FacebookIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.347 10.9c0-5.557-4.478-10.062-10-10.062-5.523 0-10 4.505-10 10.062 0 5.021 3.657 9.184 8.437 9.938v-7.03H6.245v-2.909h2.54V8.683c0-2.522 1.492-3.914 3.776-3.914 1.094 0 2.239.196 2.239.196v2.476h-1.261c-1.242 0-1.63.776-1.63 1.571V10.9h2.774l-.444 2.909h-2.33v7.03c4.78-.754 8.438-4.917 8.438-9.939z"
  }));
};
FacebookIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "currentColor"
};
var YoutubeIcon = function YoutubeIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M23.33 6.992c-.222-1.225-1.279-2.117-2.506-2.395-1.835-.39-5.233-.668-8.909-.668-3.674 0-7.125.279-8.963.668C1.727 4.875.668 5.71.446 6.992.222 8.384 0 10.332 0 12.838c0 2.506.222 4.455.5 5.847.224 1.225 1.281 2.116 2.506 2.395 1.949.39 5.29.668 8.966.668 3.676 0 7.017-.279 8.966-.668 1.224-.279 2.281-1.114 2.505-2.395.222-1.392.5-3.397.557-5.847-.113-2.505-.392-4.454-.67-5.846zM8.91 16.736V8.941l6.792 3.897-6.793 3.898z"
  }));
};
YoutubeIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var InstagramIcon = function InstagramIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.84c-2.716 0-3.056.011-4.123.06-1.064.048-1.791.217-2.427.465a4.901 4.901 0 0 0-1.772 1.153 4.901 4.901 0 0 0-1.153 1.771c-.247.636-.416 1.363-.465 2.428C2.012 9.783 2 10.124 2 12.84c0 2.715.012 3.056.06 4.123.049 1.064.218 1.79.465 2.427a4.902 4.902 0 0 0 1.153 1.771 4.902 4.902 0 0 0 1.772 1.154c.636.247 1.363.416 2.427.464 1.067.05 1.407.06 4.123.06s3.056-.01 4.123-.06c1.064-.048 1.791-.217 2.427-.464a4.902 4.902 0 0 0 1.772-1.154 4.902 4.902 0 0 0 1.153-1.771c.247-.636.416-1.363.465-2.427.048-1.067.06-1.408.06-4.123 0-2.716-.012-3.057-.06-4.123-.049-1.065-.218-1.792-.465-2.428a4.902 4.902 0 0 0-1.153-1.771 4.902 4.902 0 0 0-1.772-1.153c-.636-.248-1.363-.417-2.427-.465-1.067-.049-1.407-.06-4.123-.06zm0 1.801c2.67 0 2.986.01 4.04.059.976.044 1.505.207 1.858.344.466.181.8.398 1.15.748.35.35.566.683.748 1.15.137.352.3.882.344 1.857.048 1.054.058 1.37.058 4.04s-.01 2.987-.058 4.042c-.045.974-.207 1.504-.344 1.856-.182.467-.398.8-.748 1.15-.35.35-.683.567-1.15.748-.353.137-.882.3-1.857.345-1.054.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.04-.058-.976-.045-1.505-.208-1.858-.345a3.097 3.097 0 0 1-1.15-.748 3.098 3.098 0 0 1-.748-1.15c-.137-.352-.3-.882-.344-1.856-.048-1.055-.058-1.371-.058-4.041 0-2.67.01-2.987.058-4.041.045-.975.207-1.505.344-1.857.182-.467.399-.8.748-1.15.35-.35.684-.567 1.15-.748.353-.137.882-.3 1.857-.344C9.014 4.652 9.33 4.64 12 4.64z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.173a3.333 3.333 0 1 1 0-6.667 3.333 3.333 0 0 1 0 6.667zm0-8.469a5.135 5.135 0 1 0 0 10.27 5.135 5.135 0 0 0 0-10.27zM18.538 7.501a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0z"
  }));
};
InstagramIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var PinterestIcon = function PinterestIcon(props) {
  return __jsx("svg", props, __jsx("defs", null, __jsx("style", null, ".cls-1", "{", "fill:currentColor", "}")), __jsx("path", {
    className: "cls-1",
    d: "M250 20C123.09 20 20 123.09 20 250s103.09 230 230 230 230-103.09 230-230S376.91 20 250 20zm0 20a210 210 0 1 1-61 411c8.61-14.39 19.71-34.94 24.13-51.92C215.71 389 226.48 348 226.48 348c7 13.37 27.47 24.69 49.26 24.69 64.84 0 111.58-59.63 111.58-133.73 0-71-58-124.18-132.55-124.18-92.8 0-142.06 62.28-142.06 130.09 0 31.54 16.78 70.8 43.64 83.3 4.07 1.9 6.25 1.08 7.19-2.87.71-3 4.34-17.58 6-24.37a6.45 6.45 0 0 0-1.48-6.17c-8.89-10.79-16-30.59-16-49.07 0-47.42 35.9-93.32 97.07-93.32 52.82 0 89.81 36 89.81 87.48 0 58.16-29.37 98.46-67.58 98.46-21.1 0-36.91-17.46-31.84-38.87 6.08-25.55 17.82-53.12 17.82-71.58 0-16.5-8.86-30.27-27.21-30.27-21.58 0-38.91 22.3-38.91 52.21 0 19 6.45 31.91 6.45 31.91s-21.31 90.11-25.22 106.88-2.86 39.32-1.25 56.13A210 210 0 0 1 250 40z",
    transform: "translate(-20 -20)"
  }));
};
PinterestIcon.defaultProps = {
  id: "Warstwa_1",
  "'data-name'": "Warstwa 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "currentColor",
  viewBox: "0 0 460 460"
};
var defaultProps = {
  additionalSeparator: true,
  hoverColor: "neutral700",
  socialElementsAndLanguagePickerAsColumn: true,
  bgColor: "neutral",
  fontColor: "black",
  additionalFont: "label2",
  headingFont: "heading3",
  submenuFont: "body2",
  linksUnderline: true,
  topPadding: true,
  desktopTopPadding: "s12",
  threeColumns: false,
  directLinks: false
};
var isColumnFilled = function isColumnFilled(footerColumn) {
  var _footerColumn$items, _footerColumn$title, _footerColumn$content;
  return (footerColumn === null || footerColumn === void 0 ? void 0 : (_footerColumn$items = footerColumn.items) === null || _footerColumn$items === void 0 ? void 0 : _footerColumn$items.length) > 0 || (footerColumn === null || footerColumn === void 0 ? void 0 : (_footerColumn$title = footerColumn.title) === null || _footerColumn$title === void 0 ? void 0 : _footerColumn$title.length) || (footerColumn === null || footerColumn === void 0 ? void 0 : (_footerColumn$content = footerColumn.content) === null || _footerColumn$content === void 0 ? void 0 : _footerColumn$content.length);
};
var Footer = function Footer(_ref) {
  var _footerContent$social, _footerContent$social2, _footerContent$rights;
  var contentBlocks = _ref.contentBlocks,
    socialMediaElements = _ref.socialMediaElements,
    _ref$socialElementsAn = _ref.socialElementsAndLanguagePickerAsColumn,
    socialElementsAndLanguagePickerAsColumn = _ref$socialElementsAn === void 0 ? defaultProps.socialElementsAndLanguagePickerAsColumn : _ref$socialElementsAn,
    additionalInfo = _ref.additionalInfo,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? defaultProps.bgColor : _ref$bgColor,
    _ref$fontColor = _ref.fontColor,
    fontColor = _ref$fontColor === void 0 ? defaultProps.fontColor : _ref$fontColor,
    _ref$additionalFont = _ref.additionalFont,
    additionalFont = _ref$additionalFont === void 0 ? defaultProps.additionalFont : _ref$additionalFont,
    _ref$additionalSepara = _ref.additionalSeparator,
    additionalSeparator = _ref$additionalSepara === void 0 ? defaultProps.additionalSeparator : _ref$additionalSepara,
    _ref$hoverColor = _ref.hoverColor,
    hoverColor = _ref$hoverColor === void 0 ? defaultProps.hoverColor : _ref$hoverColor,
    footerContent = _ref.footerContent,
    languages = _ref.languages,
    _ref$headingFont = _ref.headingFont,
    headingFont = _ref$headingFont === void 0 ? defaultProps.headingFont : _ref$headingFont,
    _ref$submenuFont = _ref.submenuFont,
    submenuFont = _ref$submenuFont === void 0 ? defaultProps.submenuFont : _ref$submenuFont,
    _ref$linksUnderline = _ref.linksUnderline,
    linksUnderline = _ref$linksUnderline === void 0 ? defaultProps.linksUnderline : _ref$linksUnderline,
    _ref$topPadding = _ref.topPadding,
    topPadding = _ref$topPadding === void 0 ? defaultProps.topPadding : _ref$topPadding,
    _ref$desktopTopPaddin = _ref.desktopTopPadding,
    desktopTopPadding = _ref$desktopTopPaddin === void 0 ? defaultProps.desktopTopPadding : _ref$desktopTopPaddin,
    _ref$threeColumns = _ref.threeColumns,
    threeColumns = _ref$threeColumns === void 0 ? defaultProps.threeColumns : _ref$threeColumns,
    _ref$directLinks = _ref.directLinks,
    directLinks = _ref$directLinks === void 0 ? defaultProps.directLinks : _ref$directLinks;
  var translations = {
    rights: (0, _langLibrary["default"])("© 2020 DAJAR All rights reserved.")
  };
  var generateColumnLink = function generateColumnLink(item) {
    var routeFromUrl = (0, _getRouteFromUrl["default"])(item.url);
    var linkContent = __jsx(_LinkRaw["default"], {
      sx: {
        color: fontColor,
        textDecoration: "none",
        ":hover": {
          color: hoverColor
        }
      }
    }, item.text);
    return directLinks ? __jsx(Link, {
      href: item.url.includes(".") ? "https://" + item.url : item.url
    }, linkContent) : __jsx(Link, {
      route: routeFromUrl !== null && routeFromUrl !== void 0 ? routeFromUrl : item.url,
      params: {
        url: item.url
      }
    }, linkContent);
  };
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(_Box["default"], {
    id: "footer",
    sx: {
      bg: bgColor
    }
  }, __jsx(_Container["default"], {
    sx: {
      pt: topPadding ? ["s10", null, null, desktopTopPadding, null, null] : 0,
      pb: ["s10", null, null, "s8", null, null],
      mt: topPadding ? 0 : "-35px",
      font: submenuFont,
      color: fontColor
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: ["column", null, null, "row", null, null],
      flexWrap: "nowrap"
    }
  }, __jsx(_Box["default"], {
    sx: {
      flexBasis: [null, null, null, "80%", "70%", "50%"]
    }
  }, contentBlocks && contentBlocks.length > 0 && __jsx(_Grid["default"], {
    cols: [2, null, null, contentBlocks.length, null, null]
  }, contentBlocks && contentBlocks.map(function (block) {
    return __jsx(_Box["default"], {
      sx: {
        mb: (0, _core.lin)("s4", "s7"),
        p: {
          m: "s0",
          font: headingFont
        },
        ul: {
          display: "flex",
          flexDirection: "column",
          listStyleType: "none",
          p: "s0",
          mt: "s9",
          mb: "s0"
        },
        li: {
          lineHeight: "40px"
        },
        a: {
          color: fontColor,
          textDecoration: "none",
          ":hover": {
            color: hoverColor
          }
        }
      },
      key: "grid-" + block.id,
      dangerouslySetInnerHTML: {
        __html: block.content
      }
    });
  })), footerContent && footerContent !== _prismicErrorHandle.TIMEOUT && __jsx(_Grid["default"], {
    cols: [threeColumns ? 2 : 1, 2, null, threeColumns ? 3 : 4, null, null]
  }, footerContent && footerContent.columns.map(function (footerColumn, index) {
    return isColumnFilled(footerColumn) && __jsx(_Box["default"], {
      key: index,
      sx: {
        mb: (0, _core.lin)("s4", "s7")
      }
    }, __jsx(_Box["default"], {
      sx: {
        m: "s0",
        font: headingFont
      }
    }, footerColumn.title), __jsx(_Box["default"], {
      as: "ul",
      sx: {
        display: "flex",
        flexDirection: "column",
        listStyleType: "none",
        p: "s0",
        mt: "s9",
        mb: "s0",
        a: {
          color: fontColor,
          textDecoration: "none",
          ":hover": {
            color: hoverColor
          }
        }
      }
    }, footerColumn.items.map(function (item, index) {
      return __jsx(_Box["default"], {
        as: "li",
        key: index,
        sx: {
          lineHeight: "40px"
        }
      }, generateColumnLink(item));
    }), footerColumn.content && __jsx(_Box["default"], {
      as: "li",
      sx: {
        p: {
          mt: "s5"
        }
      }
    }, _prismicReactjs.RichText.render(footerColumn.content))));
  }))), socialElementsAndLanguagePickerAsColumn && __jsx(_Box["default"], {
    sx: {
      flexBasis: [null, null, null, "20%", "30%", "50%"],
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: ["center", null, null, "flex-end", null, null]
    }
  }, socialMediaElements === null || socialMediaElements === void 0 ? void 0 : socialMediaElements.map(function (social, index) {
    return __jsx(_Box["default"], {
      key: index,
      sx: {
        mx: ["s8", null, null, "s7", null, null],
        maxWidth: "24px",
        minWidth: "24px",
        fill: fontColor,
        ":hover": {
          fill: hoverColor
        },
        ":last-child": {
          mr: ["s8", null, null, "s0", null, null]
        },
        mt: ["s10", null, null, "s0", null, null]
      }
    }, __jsx(_LinkRaw["default"], {
      href: social.url,
      title: social.name
    }, __jsx(social.img, null)));
  }), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      flexBasis: [threeColumns ? "165px" : "50%", null, null, "80%", "50%", threeColumns ? "130px" : "22.3%"],
      maxWidth: threeColumns ? "165px" : "156px"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      mb: "s8"
    }
  }, footerContent === null || footerContent === void 0 ? void 0 : (_footerContent$social = footerContent.social) === null || _footerContent$social === void 0 ? void 0 : _footerContent$social.map(function (social, index) {
    return __jsx(_Box["default"], {
      key: index,
      sx: {
        display: "flex",
        alignItems: "center",
        maxWidth: "24px",
        minWidth: "24px",
        maxHeight: "24px",
        minHeight: "24px",
        textAlign: "center",
        "a:hover": {
          fill: hoverColor
        },
        mt: ["s10", null, null, "s0", null, null],
        a: {
          color: fontColor,
          display: "inline-block",
          width: "24px"
        }
      }
    }, __jsx("a", {
      href: social.url,
      title: social.text
    }, social.text.toLowerCase() === "facebook" ? __jsx(FacebookIcon, null) : social.text.toLowerCase() === "youtube" ? __jsx(YoutubeIcon, null) : social.text.toLowerCase() === "instagram" ? __jsx(InstagramIcon, null) : social.text.toLowerCase() === "pinterest" ? __jsx(PinterestIcon, null) : undefined));
  })), languages && __jsx(_Box["default"], null, languages)))), !socialElementsAndLanguagePickerAsColumn && __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: ["column", null, null, "row", null, null],
      alignItems: "center",
      mt: "s11"
    }
  }, languages && __jsx(_Box["default"], null, languages), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row"
    }
  }, footerContent === null || footerContent === void 0 ? void 0 : (_footerContent$social2 = footerContent.social) === null || _footerContent$social2 === void 0 ? void 0 : _footerContent$social2.map(function (social, index) {
    return __jsx(_Box["default"], {
      key: index,
      sx: {
        maxWidth: "24px",
        height: "24px",
        minWidth: "24px",
        mt: ["s8", null, null, 0],
        ml: [index > 0 ? "s5" : 0, null, null, "s10"],
        svg: {
          fill: fontColor,
          ":hover": {
            fill: hoverColor
          }
        }
      }
    }, __jsx(Link, {
      href: social.url
    }, __jsx(_LinkRaw["default"], {
      title: social.text
    }, social.text === "Facebook" ? __jsx(FacebookIcon, null) : social.text === "YouTube" ? __jsx(YoutubeIcon, null) : social.text === "Instagram" ? __jsx(InstagramIcon, null) : undefined)));
  }))), __jsx(_Grid["default"], {
    cols: 1
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: ["column", null, null, "row", null, null],
      mt: [threeColumns ? "s8" : "s10", null, null, "s12", null, null]
    }
  }, __jsx(_Box["default"], {
    sx: {
      textAlign: "center",
      font: additionalFont,
      pr: "s3",
      mb: ["s5", null, null, "s0", null, null]
    }
  }, footerContent !== null && footerContent !== void 0 && footerContent.rights ? __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexWrap: threeColumns ? ["wrap", null, null, "nowrap"] : "nowrap",
      justifyContent: "center"
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, !threeColumns && {
      display: ["none", null, null, "block"]
    }), {}, {
      mr: threeColumns ? "s3" : "s6",
      flexBasis: threeColumns ? ["100%", null, null, "auto"] : "auto",
      mb: threeColumns ? ["s4", null, null, 0] : 0
    })
  }, footerContent.rights.text), footerContent.rights.items.map(function (link, index) {
    var routeFromUrl = (0, _getRouteFromUrl["default"])(link.url);
    return __jsx(_Box["default"], {
      sx: {
        px: threeColumns ? 0 : ["s4", null, null, 0]
      }
    }, __jsx(_Box["default"], {
      as: "span",
      sx: {
        display: [index === 0 ? "none" : "inline", null, null, "inline"]
      }
    }, threeColumns ? "|" : ""), __jsx(Link, {
      key: index,
      route: routeFromUrl ? routeFromUrl : link.url,
      params: {
        url: link.url
      }
    }, __jsx(_LinkRaw["default"], {
      title: link.text,
      sx: {
        ml: threeColumns ? "s3" : [0, null, null, "s7"],
        textDecoration: linksUnderline ? "underline" : "none",
        ":hover": {
          color: hoverColor
        },
        mr: threeColumns ? "s3" : 0
      }
    }, link.text)));
  })) : translations.rights), additionalInfo && __jsx(_Box["default"], {
    sx: {
      textAlign: "center",
      font: additionalFont
    }
  }, additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.map(function (additional, index) {
    return __jsx(Link, {
      route: additional.url
    }, __jsx(_LinkRaw["default"], {
      key: index,
      title: additional.name
    }, additionalSeparator && __jsx(_Box["default"], {
      as: "span",
      sx: index === 0 && {
        display: ["none", null, null, "inline", null, null]
      }
    }, "|"), __jsx(_Box["default"], {
      as: "span",
      sx: {
        px: "s3",
        cursor: "pointer",
        textDecoration: "underline"
      }
    }, additional.name)));
  })), __jsx(_Box["default"], {
    sx: {
      display: threeColumns ? "none" : ["block", null, null, "none"],
      textAlign: "center",
      flexBasis: threeColumns ? ["100%", null, null, "auto"] : "auto",
      mt: "s7",
      font: additionalFont
    }
  }, footerContent === null || footerContent === void 0 ? void 0 : (_footerContent$rights = footerContent.rights) === null || _footerContent$rights === void 0 ? void 0 : _footerContent$rights.text)))));
};
var _default = Footer;
exports["default"] = _default;